<template>
    <div class="pr-1">
        <img src="@/assets/svg/edit-3.svg" alt="edit" class="edit" @click="goToUpdatePage">
    </div>
</template>

<script>
export default {
  props: {
    row: {
      type: Object,
      required: true
    }
  },
  methods: {
    goToUpdatePage () {
      let type = this.$route.params.service_type
      this.$router.push({ path: `/travels/${type}/${this.row.id}` })
    }
  }
}
</script>

<style>
    .edit:hover {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/datatable/TravelsEditButton.vue